<template>
  <div class="row d-flex justify-content-center">
    <div class="col-10 mt-2">
      <el-card shadow="always" class="p-0" style="border-radius: 10px;" :body-style="{ padding: '0px' }">
        <div class="row bg-navy py-2 px-3 mb-5">
          <div class="col-12 text-center">
            <h3 class="mb-0 text-white text-uppercase">Complete</h3>
          </div>
        </div>
        <div class="mx-5">
          <div class="row mb-5">
            <div class="col-12 text-center">
              <p class="font-lg text-navy">Setup complete. Thank you for taking the time to provide us with this
                information.</p>
              <p class="font-lg text-navy">We will be in touch shortly with the onboarding documents for e-signature.
                Please keep an
                eye on your
                emails for these.</p>
              <p class="font-lg text-navy">if you have any questions in the meantime please do not hesitate to contact our
                office on
                <strong>02 6750
                  9405</strong> or email <strong>admin@ottleycapital.com</strong>
              </p>
              <el-button class="action-btn text-uppercase my-4" type="primary" @click="$emit('save-data')">
                Finish
              </el-button>
            </div>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>
<script>

export default {
  props: {
  },
  mounted() {

  },
  data() {
    return {

    };
  },
  methods: {

  },
};
</script>